import { useMutation } from "react-query";

import axios from "../../../../utils/authAxios";

const apiBaseUrl =
  process.env.REACT_APP_API_BASEURL + "/BusinessLicensePermits";

export interface DownloadBLPExcelRequest {
  dashboardFilter?: string | null;
  officeId?: number | null;

  busLicensePermitTypeId?: number[];
  issuerId?: number[];
  licenseOrPermitNumberId?: string[];
  storeNumberId?: string[];

  licenseStatusId?: number | null;
  isOldLicense?: boolean | null;

  search?: string | null;
}

const appendArray = (
  params: URLSearchParams,
  key: string,
  values?: Array<string | number>,
) => {
  values?.forEach((value) => {
    params.append(key, String(value));
  });
};

const downloadBLPExcel = async (
  request: DownloadBLPExcelRequest = {},
): Promise<void> => {
  const params = new URLSearchParams();

  if (request.dashboardFilter) {
    params.append("DashboardFilter", request.dashboardFilter);
  }

  if (request.officeId !== null && request.officeId !== undefined) {
    params.append("OfficeId", String(request.officeId));
  }

  appendArray(params, "BusLicensePermitTypeId", request.busLicensePermitTypeId);

  appendArray(params, "Issuer", request.issuerId);

  appendArray(params, "LicenseOrPermitNumber", request.licenseOrPermitNumberId);

  appendArray(params, "StoreNumber", request.storeNumberId);

  if (
    request.licenseStatusId !== null &&
    request.licenseStatusId !== undefined
  ) {
    params.append("LicenseStatusId", String(request.licenseStatusId));
  }

  if (request.isOldLicense !== null && request.isOldLicense !== undefined) {
    params.append("IsOldLicense", String(request.isOldLicense));
  }

  if (request.search) {
    params.append("Search", request.search);
  }

  const response = await axios.get<Blob>(`${apiBaseUrl}/DownloadExcel`, {
    responseType: "blob",
    params,
  });

  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = globalThis.URL.createObjectURL(blob);

  const link = document.createElement("a");

  link.href = url;

  link.setAttribute(
    "download",
    `BusinessLicensesAndPermits_${new Date().toISOString().slice(0, 10)}.xlsx`,
  );

  document.body.appendChild(link);
  link.click();
  link.remove();

  globalThis.URL.revokeObjectURL(url);
};

export const useDownloadBLPExcel = () => {
  return useMutation<void, unknown, DownloadBLPExcelRequest | undefined>(
    (request) => downloadBLPExcel(request ?? {}),
  );
};